// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: true,
    apiUrl: 'http://localhost:60144/',
    apiUrl_TenantCode: 'localhost:60144',
    apiUrl_Tracking: 'https://tracking.ifreightbox.net/',
    apiUrlLiveTracking: '',
    apiUrlPython: '',
    //added by vithujan 16-09-2022
    maxFileSize: 10,
    //end
};


